import type { ArtifactToken, ProvenanceRecord, WideExtraction } from '@/api'

class BoundedMap<Key, Value> extends Map<Key, Value> {
  constructor(private readonly limit: number) {
    super()
  }

  override set(key: Key, value: Value): this {
    this.delete(key)
    super.set(key, value)
    while (this.size > this.limit) {
      const oldestKey = this.keys().next().value
      if (oldestKey === undefined) break
      this.delete(oldestKey)
    }
    return this
  }
}

export const wideGridCache = new BoundedMap<string, { data: WideExtraction; etag: string }>(100)
export const finalizedStateCache = new BoundedMap<string, boolean>(200)
export const completionStateCache = new BoundedMap<string, boolean>(200)
export const pageProvenanceCache = new BoundedMap<string, ProvenanceRecord[]>(600)
export const pageArtifactCache = new BoundedMap<string, ArtifactToken[]>(600)
export const pageEvidencePending = new Map<string, Promise<void>>()

export const PDF_BLOB_CACHE_LIMIT = 12
export const pdfBlobCache = new Map<string, Blob>()
export interface CachedPdfSourceUrl {
  url: string
  expiresAt: number
}
export const pdfSourceUrlCache = new BoundedMap<string, CachedPdfSourceUrl>(100)
export const pdfSourceUrlPending = new Map<string, Promise<CachedPdfSourceUrl>>()
export const pdfSourceApiFallbackCache = new BoundedMap<string, true>(100)
let cacheEpoch = 0

export function captureExtractionLoadCacheEpoch(): number {
  return cacheEpoch
}

export function isExtractionLoadCacheEpochCurrent(epoch: number): boolean {
  return epoch === cacheEpoch
}

export function resetExtractionLoadCaches(): void {
  cacheEpoch += 1
  wideGridCache.clear()
  finalizedStateCache.clear()
  completionStateCache.clear()
  pageProvenanceCache.clear()
  pageArtifactCache.clear()
  pageEvidencePending.clear()
  pdfBlobCache.clear()
  pdfSourceUrlCache.clear()
  pdfSourceUrlPending.clear()
  pdfSourceApiFallbackCache.clear()
}
